module.exports = __webpack_public_path__ + "ofis 1.jpg?a282b0b79003818a4fe70e4ac71cef6c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis 1.jpg
// module id = 353
// module chunks = 0